import React from 'react';
import headshot from "../images/Headshot.jpg"
import AnimatedText from 'react-animated-text-content';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback } from "react";

function Home() {
    const options = {
        particles: {
          number: {
            value: 6,
            density: {
              enable: true,
              value_area: 800
            }
          },
          color: {
            value: "#2d7439"
          },
          shape: {
            type: "polygon",
            stroke: {
              width: 0,
              color: "#000"
            },
            polygon: {
              nb_sides: 6
            },
            image: {
              src: "img/github.svg",
              width: 100,
              height: 100
            }
          },
          opacity: {
            value: 0.3,
            random: true,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false
            }
          },
          size: {
            value: 160,
            random: false,
            anim: {
              enable: true,
              speed: 10,
              size_min: 40,
              sync: false
            }
          },
          line_linked: {
            enable: false,
            distance: 200,
            color: "#ffffff",
            opacity: 1,
            width: 2
          },
          move: {
            enable: true,
            speed: 8,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200
            }
          }
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "repulse"
            },
            onclick: {
              enable: false,
              mode: "push"
            },
            resize: true
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1
              }
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3
            },
            repulse: {
              distance: 200,
              duration: 0.4
            },
            push: {
              particles_nb: 4
            },
            remove: {
              particles_nb: 2
            }
          }
        },
        retina_detect: true
      }
     
     ;

     const particlesInit = useCallback(async (engine) => {
  await loadFull(engine);
}, []);
    return(
        
        <div>
<Particles options={options} init={particlesInit} />
<img className='headshotResume' src={headshot} height="125px" width="125px" style={{borderRadius: "50%", marginLeft:"30%", marginTop:"2%"}}></img>
<AnimatedText
	
	style={{color:"white", textAlign:"center",textShadow: "2px 2px green", fontSize:"20PX", margin:"5%", fontFamily: "Roboto"}}
	type="words" // animate words or chars
	animation={{
		x: '200px',
		y: '-20px',
		scale: 1.1,
		ease: 'ease-in-out',
	}}
	animationType="diagonal"
	interval={0.06}
	duration={0.8}
	tag="h1"
	className="animated-paragraph"
	includeWhiteSpaces
	threshold={0.1}
	rootMargin="20%"
	
	>
	  Hello, my name is Davis Kajuna and I am a data scientist currently looking for a new job.
    In my previous data science role, depending on the project and client, I worked as a data scientist, data analyst or a data engineer
    My education credentials includes a bachelors of science in computational and data science.
    I am currently pursuing my Masters of science in statistical science part time. I am always willing 
    to learn new technologies that will elevate my data science career. When I am not studyinh, I enjoy 
    playing soccer, watching movies/series, learning and trying on new technologies in the ever growing
    world of data science. 
	
	</AnimatedText>
	
        </div>
    )

} export default Home;